import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import ClientProfile from './ClientProfile';
import SellerProfile from './SellerProfile';
import InmProfile from './InmProfile';
import ConsProfile from './ConsProfile';
import { useAuth } from '../../context/AuthContext';

const ProfileRouter = () => {
  const { nombre_usuario } = useParams();
  const location = useLocation();
  const { user } = useAuth();
  const path = location.pathname;

  // Si la ruta es /mi_perfil, mostrar el perfil según el tipo de usuario
  if (path === '/mi_perfil') {
    if (!user) return <ClientProfile />;

    switch (user.tipo_usuario_id) {
      case 1:
        return <ClientProfile />;
      case 2:
        return <SellerProfile username={user.nombre_usuario} />;
      case 3:
        return <ConsProfile username={user.nombre_usuario} />;
      case 4:
        return <InmProfile username={user.nombre_usuario} />;
      default:
        return <ClientProfile />;
    }
  }

  // Determinar el tipo de perfil basado en la ruta
  if (path.startsWith('/vendedor/')) {
    return <SellerProfile username={nombre_usuario} />;
  }
  
  if (path.startsWith('/constructora/')) {
    return <ConsProfile username={nombre_usuario} />;
  }
  
  if (path.startsWith('/inmobiliaria/')) {
    return <InmProfile username={nombre_usuario} />;
  }

  // Si no coincide con ninguna ruta específica y no es mi_perfil,
  // redirigir a una página de error o al perfil por defecto
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Perfil no encontrado</h2>
        <p className="text-gray-600">
          La ruta {path} no corresponde a ningún tipo de perfil válido.
        </p>
      </div>
    </div>
  );
};

export default ProfileRouter;